import React from 'react';
import ReactDOM from 'react-dom/client';
import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { msalConfig } from './authConfig';
import './index.css';
import App from './App';
import ErrorBoundary from './components/ErrorBoundary';

const msalInstance = new PublicClientApplication(msalConfig);

const root = ReactDOM.createRoot(document.getElementById('root'));
// BUG-09: the boundary sits OUTSIDE <MsalProvider> so it also catches a throw
// from the provider itself, not just from App's subtree. Everything the staff
// app renders — CRM, Document Manager, and the public /sign page — is under it.
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <MsalProvider instance={msalInstance}>
        <App />
      </MsalProvider>
    </ErrorBoundary>
  </React.StrictMode>
);
